import axios from "axios";

/* ------------------------------------------------------------------ */
/*  Central place to point the dashboard at your Django backend.      */
/*  Change API_BASE_URL once here (or via .env: REACT_APP_API_URL /   */
/*  VITE_API_URL) and every request below follows it.                 */
/* ------------------------------------------------------------------ */
export const API_BASE_URL =
  process.env.REACT_APP_API_URL ||
  process.env.VITE_API_URL ||
  // "http://127.0.0.1:8000";
  "https://vpback.online";

const axiosClient = axios.create({
  baseURL: API_BASE_URL,
});

/* Attach the saved access token to every outgoing request */
axiosClient.interceptors.request.use((config) => {
  const token = localStorage.getItem("vpf_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

/* ------------------------------------------------------------------ */
/*  SESSION EXPIRY                                                    */
/*  If the backend ever answers 401 (bad/expired token), we clear     */
/*  whatever we saved locally and hard-reload the page. Reloading a   */
/*  React SPA with no token in storage naturally drops the visitor    */
/*  back to a logged-out state, satisfying "session expired ->        */
/*  page reload" without needing a dedicated expiry timer.            */
/* ------------------------------------------------------------------ */
let isHandlingExpiry = false;

axiosClient.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status;
    const isLoginCall = error?.config?.url?.includes("/login");

    if (status === 401 && !isLoginCall && !isHandlingExpiry) {
      isHandlingExpiry = true;
      localStorage.removeItem("vpf_token");
      localStorage.removeItem("vpf_refresh");
      localStorage.removeItem("vpf_user");
      // Small delay so any in-flight UI state settles before the reload.
      setTimeout(() => {
        window.location.reload();
      }, 150);
    }

    return Promise.reject(error);
  }
);

export default axiosClient;
